import Joi from "joi-browser";

const BaseUnit = Joi.object().keys({
    unit: Joi.string().required().label("Unit"),
});

const ConversionUnit = Joi.object().keys({
    conversionUnit: Joi.object().required().label("Unit name"),
});

export default { BaseUnit, ConversionUnit };
